export default "__VITE_ASSET__2b4d183e__"